import React, { useRef } from 'react';
import './Contact.css';
import emailjs from 'emailjs-com';
import { Col, Container, Row } from 'react-bootstrap';
const Swal = require('sweetalert2')

const Contact = () => {

    const form = useRef();
    const sendEmail = (e) => {
        e.preventDefault();
        emailjs.sendForm('service_vib2y25', 'template_lj9u9l7', e.target, 'user_wEXZoBqFUCwvh17WGFjDP')

            .then((result) => {
                Swal.fire(
                    'Successfully!',
                    'Thanks you!',
                    'success'
                );

            }, (error) => {
                console.log(error.text);
            });


    };
    return (
        <div id="contact" className="py-5 contact-container">
            <Container>
                <div className="text-center pb-5">
                    <h1 className="text-white">Get In Touch</h1>
                    <hr className="dash" />
                </div>
                <Row>
                    <Col xs={12} md={2}></Col>
                    <Col xs={12} md={8}>
                        <div className="shadow py-5 contact-form">
                            <form ref={form} onSubmit={sendEmail}>
                                <div className="contact-info">
                                    <div data-aos="zoom-out-up" className="pb-4">
                                        <label className="pb-2" htmlFor="">Name</label> <br />
                                        <input name="name" className="form-control py-3 rounded ps-3 border-0 " placeholder="Enter Your Name" required />
                                    </div>

                                    <div data-aos="zoom-out-up" className="pb-4">
                                        <label className="pb-2" htmlFor="">Email</label> <br />
                                        <input name="email" className="form-control py-3 rounded ps-3  border-0" placeholder="Enter Your Email" required />
                                    </div>
                                    <div data-aos="zoom-out-up" className="pb-4">
                                        <label className="pb-2" htmlFor="">Message</label>
                                        <textarea name="message" className="form-control border-0 pt-3 ps-3" rows="10" placeholder="Your Message" required></textarea>
                                    </div>
                                </div>

                                <div className="text-end pt-4">
                                    <input className="px-4 py-3 btn btn-primary rounded" type="submit" value="Send Message" />
                                </div>
                            </form>
                        </div>
                    </Col>

                </Row>

            </Container>
        </div>
    );
};

export default Contact;